export const LANGUAGES = Object.freeze({
  NL: 'nl',
  EN: 'en',
  FR: 'fr',
  DE: 'de',
  PT: 'pt',
});

export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES);
